import { playerState, setPlayerState } from "@stores";
class FiringModeManager {
    firingMode;
    allowedFiringModes;
    /**
     * A firing type manager that allows changing between the firing modes for a gun.
     * @param firingMode The initial firing mode.
     * @param allowedFiringModes The allowed firing modes for a gun.
     * @throws Throws an error if the given firing mode is incompatible with the gun.
     */
    constructor(firingMode, allowedFiringModes) {
        this.allowedFiringModes = allowedFiringModes;
        this.change(firingMode);
    }
    /**
     * Change to a different firing mode.
     * @param firingMode The firing mode to change to.
     * @throws Throws an error if the given firing mode is incompatible with the gun.
     */
    change(firingMode) {
        if (this.allowedFiringModes.length === 1)
            return;
        this.verifyFiringMode(firingMode);
        this.firingMode = firingMode;
    }
    /**
     * Change to the next firing type. This depends on the order in which the firing types were submitted to the constructor.
     * If the end of the allowed firing types is reached, start back from the first one.
     * @throws Throws an error if the given firing mode is incompatible with the gun.
     */
    getNext() {
        if (this.allowedFiringModes.length === 1)
            return;
        let index = this.allowedFiringModes.findIndex(allowedFiringMode => this.firingMode.constructor === allowedFiringMode.constructor);
        if (index < 0)
            throw new Error(`The firing mode '${this.firingMode.getName}' could not be found among the gun's allowed firing types.`);
        if (index >= this.allowedFiringModes.length - 1) {
            index = 0;
        }
        else {
            index += 1;
        }
        const firingMode = this.allowedFiringModes[index];
        this.change(firingMode);
        setPlayerState({
            ...playerState(),
            gun: { ...playerState().gun, firingMode: firingMode.getShortName },
        });
    }
    /**
     * Verify that the firing mode is compatible with the gun.
     * @param firingMode The firing mode to verify.
     * @throws Throws an error if the given firing mode is incompatible with the gun.
     */
    verifyFiringMode(firingMode) {
        if (!this.allowedFiringModes.some(mode => firingMode.constructor === mode.constructor))
            throw new Error(`Firing in ${firingMode.getName} is not supported on this gun.`);
    }
    get getAllowedFiringModes() {
        return this.allowedFiringModes;
    }
    get getFiringMode() {
        return this.firingMode;
    }
}
export { FiringModeManager };
